import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ThemeProvider, Typography, styled, useTheme } from '@mui/material';
import { AUTHORITIES } from 'app/config/constants';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { showElement } from 'app/shared/util/data-utils';
import React from 'react';
import { Link } from 'react-router-dom';
import '../../modules/truck-implement/truckImplement.scss';
import { TruckImplementInfoCard } from '../dashboards/dashboard-truck-implement/components/truck-implement-info-tab/TruckImplementInfoCard';
interface IModalProps {
  implement: any;
  toggle: () => void;
  isOpen: boolean | null;
  sensorDataValues: any | null;
}

export const TruckImplementModal = ({ implement, toggle, isOpen, sensorDataValues }: IModalProps) => {
  const theme = useTheme();

  const isRepresentativeAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.REPRESENTATIVE_ADMIN]));
  const isTransporterAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.TRANSPORTER_ADMIN]));
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const loading = useAppSelector(state => state.truckImplement.loading);

  const themeVariant = theme.palette.mode === 'dark' ? true : false;
  const borderVariant = themeVariant === true ? '' : '2px solid #D5D5D5';

  const handleClose = () => {
    toggle();
  };

  const ButtonActions = propsButton => (
    <Button {...propsButton} component={Link} sx={{ gap: '4px', margin: '5px', textTransform: 'none', padding: '8px 22px;', height: '38px' }}>
      {propsButton.children}
    </Button>
  );

  const { id, licensePlate } = implement;

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={isOpen}
        onBackdropClick={handleClose}
        scroll="body"
        sx={{
          border: borderVariant,
          '& .MuiPaper-root': {
            margin: '10px',
            borderRadius: '16px',
            backgroundColor: theme.palette.background.default,
            [theme.breakpoints.down('md')]: {
              maxWidth: '92vw !important',
            },
          },
        }}
      >
        <BoxModal
          sx={{
            animation: isOpen ? 'slideIn 0.2s ease-in-out forwards' : 'none',
            '@keyframes slideIn': {
              from: { transform: 'translateY(-100%)', opacity: 0 },
              to: { transform: 'translateY(0%)', opacity: 1 },
            },
          }}
        >
          <DialogTitle>
            <BoxModalTittle id={'parent-modal-title'}>
              <SpanPlate>
                <DivTruckPlate>
                  <strong title={licensePlate}>{licensePlate}</strong>
                </DivTruckPlate>
              </SpanPlate>
              <IconButton onClick={handleClose} edge="end" color="secondary" sx={{}}>
                <Close></Close>
              </IconButton>
            </BoxModalTittle>
          </DialogTitle>
          <DialogContent sx={{ padding: '8px 24px 10px 24px' }}>
            <TruckImplementInfoCard id={'parent-modal-description'} isModal={true} props={implement} dataProps={sensorDataValues} />
          </DialogContent>
          <DialogActions sx={{ padding: '0px 0px 10px 0px' }}>
            <BoxFooter>
              <ButtonActions
                style={showElement(isAdmin || isRepresentativeAdmin || isTransporterAdmin)}
                to={`/truck-implement/${id}/edit`}
                disabled={loading}
                variant="contained"
                color="secondary"
              >
                <Typography>Editar ativo</Typography>
              </ButtonActions>
            </BoxFooter>
          </DialogActions>
        </BoxModal>
      </Dialog>
    </ThemeProvider>
  );
};

const BoxModal = styled(Box)(({ theme }) => ({
  borderRadius: '16px',
  backgroundColor: theme.palette.background.default,
  animation: 'slideIn 0.4s ease-in-out forwards',
  overflow: 'hidden',
  [theme.breakpoints.down('xl')]: {
    width: '460px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const BoxFooter = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const BoxModalTittle = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  top: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    height: '10px',
    justifyContent: 'center',
  },
}));

const SpanPlate = styled('span')(({ theme }) => ({
  display: 'flex',
  width: '90%',
  height: '30px',
  color: theme.palette.text.primary,
}));

const DivTruckPlate = styled('div')(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '36px',
  marginRight: '32px',
  height: '30px',
  [theme.breakpoints.down('md')]: {
    height: '20px',
    marginRight: '5px',
    fontSize: '18px',
  },
}));

export default TruckImplementModal;
